export default {
    artists: {},
    filters: {
        day: 'Thursday',
        location: ''
    },
    locationsFilterList: []
}